// App-owned sharing wiring for the concrete beam app (NOT synced — edit freely).
// Binds the @structura/sharing workspace package to this app's API base, token, and router.

import React from 'react'
import { Link } from 'react-router-dom'
import { createSharingClient, renderGenericArtifact, type SharingLinkComponent } from '@structura/sharing'
import { apiConfig } from '@structura/services'

export const sharingClient = createSharingClient({
  apiBase: `${apiConfig.baseUrl}/api`,
  getToken: () => localStorage.getItem('structura.auth.token'),
})

export const typeLabel = (resourceType: string): string =>
  resourceType === 'beam-design' ? 'Bjelke' : resourceType

// No dedicated read-only report component yet — the generic renderer suffices.
export const renderArtifact = renderGenericArtifact

export const RouterLink: SharingLinkComponent = ({ href, className, children }) => (
  <Link to={href} className={className}>{children}</Link>
)
